import { ViewerFloorsDictionary } from "../models/viewerFloorsDictionary";

export class AutodeskContext {
	public constructor(
		public viewerFloors: ViewerFloorsDictionary = new ViewerFloorsDictionary(),
		public activeVenueId?: string,
		public model?: Autodesk.Viewing.Model,
		public activeFloorLevel?: number
	) { }
}
